import { ref, watch, computed } from "@vue/composition-api";
import store from "@/store";
import { useRouter } from "@core/utils/utils";

// Notification
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default function useCountriesList() {
  // Use toast
  const toast = useToast();
  const { route, router } = useRouter();

  const refCountriesListTable = ref(null);

  // Table Handlers
  const tableColumns = [
    { label: "Nº", key: "index", sortable: true },
    { label: "libellé", key: "name", sortable: true },
    { label: "code", key: "code", sortable: true },
    { key: "actions" },
  ];
  const perPage = ref(10);
  const currentPage = ref(1);
  const perPageOptions = [10, 25, 50, 100];
  const searchQuery = ref("");
  const sortBy = ref("created_at");
  const isSortDirDesc = ref(true);


  const countriesList = computed(() => {
    return store.getters["country/all"];
  });

  const totalCountries = computed(() => {
    const meta = store.getters["country/meta"];
    return meta.total ?? 0;
  });

  const dataMeta = computed(() => {
    const localItemsCount = refCountriesListTable.value
      ? refCountriesListTable.value.localItems.length
      : 0;
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalCountries.value,
    };
  });

  const refetchData = () => {
    refCountriesListTable.value.refresh();
  };

  watch(
    [currentPage, perPage, searchQuery],
    () => {
      refetchData();
    }
  );

  const fetchCountriesList = (ctx, callback) => {
    store
      .dispatch("country/fetchCountriesList", {
        q: searchQuery.value,
        perPage: perPage.value,
        page: currentPage.value,
        sortBy: sortBy.value,
        sortDesc: isSortDirDesc.value,
      })
      .then(() => {
        callback(countriesList.value);
      })
  };

  const deleteCountry = async (brandID) => {
    const { data, status } = await store.dispatch("country/destroyCountry", {
      id: countryID,
    });
    if (status != 200) {
      toast({
        component: ToastificationContent,
        props: {
          title: data.error,
          icon: "AlertTriangleIcon",
          variant: "error",
        },
      });
    } else {
      toast({
        component: ToastificationContent,
        props: {
          title: "Le pays a été supprimé avec succès.",
          icon: "AlertTriangleIcon",
          variant: "success",
        },
      });
      refetchData();
    }
  };


  return {
    fetchCountriesList,
    tableColumns,
    perPage,
    currentPage,
    totalCountries,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refCountriesListTable,
    refetchData,
    deleteCountry,
  };
}
